document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.mm-bb[data-section-id]').forEach(function (section) {
        initBundleBuilder(section);
    });
});

function initBundleBuilder(section) {
    if (typeof Swiper !== 'undefined') {
        const thumbsEl = section.querySelector('.bb-thumbs-swiper');
        const heroEl = section.querySelector('.bb-hero-swiper');
        const prevBtn = section.querySelector('[data-bb-thumbs-prev]');
        const nextBtn = section.querySelector('[data-bb-thumbs-next]');
        let thumbsSwiper = null;

        function updateThumbsNav(swiper) {
            if (!prevBtn || !nextBtn || !swiper) return;

            prevBtn.setAttribute('aria-label', 'Previous product image');
            nextBtn.setAttribute('aria-label', 'Next product image');

            const needsNav = swiper.slides.length > swiper.params.slidesPerView;

            if (!needsNav) {
                prevBtn.classList.add('is-hidden');
                nextBtn.classList.add('is-hidden');
                return;
            }

            if (swiper.isBeginning) {
                prevBtn.classList.add('is-hidden');
            } else {
                prevBtn.classList.remove('is-hidden');
            }

            if (swiper.isEnd) {
                nextBtn.classList.add('is-hidden');
            } else {
                nextBtn.classList.remove('is-hidden');
            }
        }

        if (thumbsEl) {
            thumbsSwiper = new Swiper(thumbsEl, {
                slidesPerView: 3,
                spaceBetween: 5,
                watchSlidesProgress: true,
                navigation: {
                    prevEl: prevBtn,
                    nextEl: nextBtn
                },
                a11y: {
                    prevSlideMessage: 'Previous product image',
                    nextSlideMessage: 'Next product image'
                },
                on: {
                    init: function () {
                        updateThumbsNav(this);
                    },
                    slideChange: function () {
                        updateThumbsNav(this);
                    },
                    resize: function () {
                        updateThumbsNav(this);
                    }
                }
            });
        }

        if (heroEl) {
            new Swiper(heroEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                grabCursor: true,
                thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
                on: {
                    slideChange: function () {
                        if (thumbsSwiper) {
                            updateThumbsNav(thumbsSwiper);
                        }
                    }
                }
            });
        }

        function bringThumbIntoView(slide) {
            if (!thumbsSwiper || !slide || !slide.parentNode) return;

            const siblings = slide.parentNode.children;
            const idx = Array.prototype.indexOf.call(siblings, slide);
            if (idx < 0) return;

            const viewport = thumbsSwiper.el.getBoundingClientRect();
            const rect = slide.getBoundingClientRect();
            const notFullyVisible = rect.left < viewport.left - 1 || rect.right > viewport.right + 1;
            const nextSlide = siblings[idx + 1];
            const prevSlide = siblings[idx - 1];
            const nextHidden = !!(nextSlide && nextSlide.getBoundingClientRect().right > viewport.right + 1);
            const prevHidden = !!(prevSlide && prevSlide.getBoundingClientRect().left < viewport.left - 1);

            if (notFullyVisible || nextHidden) {
                thumbsSwiper.slideTo(idx);
            } else if (prevHidden) {
                const perView = parseInt(thumbsSwiper.params.slidesPerView, 10) || 1;
                let target = idx - (perView - 1);
                if (target < 0) target = 0;
                thumbsSwiper.slideTo(target);
            }

            updateThumbsNav(thumbsSwiper);
        }

        if (thumbsEl) {
            thumbsEl.querySelectorAll('.swiper-slide').forEach(function (slide) {
                slide.addEventListener('click', function () {
                    bringThumbIntoView(slide);
                });
            });
        }
    }

    const minQty = parseInt(section.dataset.minQty, 10) || 3;
    const requiredText = section.dataset.requiredText || 'Quantity Required';
    const defaultText = section.dataset.defaultText || 'Add to Cart';

    const tierEls = Array.prototype.slice
        .call(section.querySelectorAll('.bb-tier-col'))
        .map(function (col) {
            return {
                el: col,
                min: parseInt(col.dataset.tierMin, 10) || 0,
                discount: parseFloat(col.dataset.tierDiscount) || 0
            };
        });

    const tiers = tierEls
        .filter(function (t) { return t.discount > 0; })
        .sort(function (a, b) { return b.min - a.min; });

    const atcBtn = section.querySelector('[data-bb-atc]');
    const atcText = section.querySelector('[data-bb-atc-text]');
    const counterEl = section.querySelector('[data-bb-counter]');
    const rows = Array.prototype.slice.call(section.querySelectorAll('.bb-row'));

    function getTotals() {
        let totalQty = 0;
        let totalPrice = 0;

        rows.forEach(function (row) {
            const input = row.querySelector('.bb-qty-input');
            const qty = parseInt(input.value, 10) || 0;
            const price = parseFloat(row.dataset.variantPrice) / 100;
            totalQty += qty;
            totalPrice += qty * price;
        });

        for (let i = 0; i < tiers.length; i++) {
            if (totalQty >= tiers[i].min) {
                totalPrice = totalPrice - (tiers[i].discount * totalQty);
                break;
            }
        }

        if (totalPrice < 0) totalPrice = 0;

        return { qty: totalQty, price: totalPrice };
    }

    function updateTierTrack() {
        const tierRow = section.querySelector('.bb-tier-row');

        if (!tierRow || tierEls.length <= 1) return;

        const stars = tierRow.querySelectorAll('.bb-tier-star');

        if (stars.length < 2) return;

        const gap = 12;
        const rowRect = tierRow.getBoundingClientRect();
        const firstStar = stars[0].getBoundingClientRect();
        const lastStar = stars[stars.length - 1].getBoundingClientRect();
        const trackLeft = firstStar.right - rowRect.left + gap;
        const trackRight = rowRect.right - lastStar.left + gap;
        const trackWidth = Math.max(0, rowRect.width - trackLeft - trackRight);
        const trackTop = firstStar.top + firstStar.height / 2 - rowRect.top;

        tierRow.style.setProperty('--tier-track-left', trackLeft + 'px');
        tierRow.style.setProperty('--tier-track-width', trackWidth + 'px');
        tierRow.style.setProperty('--tier-track-top', trackTop + 'px');
    }

    function refreshTiers(totalQty) {
        let highestActiveIndex = -1;

        tierEls.forEach(function (t, index) {
            if (totalQty >= t.min) {
                t.el.classList.add('is-active');
                highestActiveIndex = index;
            } else {
                t.el.classList.remove('is-active');
            }
        });

        const tierRow = section.querySelector('.bb-tier-row');

        if (!tierRow || tierEls.length <= 1) return;

        const ratio = highestActiveIndex >= 0
            ? (highestActiveIndex + 1) / tierEls.length
            : 0;

        tierRow.style.setProperty('--tier-progress-ratio', ratio);
        updateTierTrack();
    }

    function refreshAtc() {
        const t = getTotals();
        refreshTiers(t.qty);

        if (counterEl) {
            counterEl.textContent = t.qty;
        }

        if (t.qty < minQty) {
            atcBtn.disabled = true;
            atcText.textContent = requiredText;
        } else {
            atcBtn.disabled = false;
            atcText.textContent = defaultText;
        }
    }

    function getRowCartVariantIds(row) {
        const ids = [row.dataset.variantId];

        if (row.dataset.mappedVariantIds) {
            row.dataset.mappedVariantIds.split(',').forEach(function (id) {
                if (id) ids.push(id);
            });
        }

        return ids;
    }

    function syncRowsFromCart(cart) {
        if (!cart || !cart.items) return;

        rows.forEach(function (row) {
            const ids = getRowCartVariantIds(row);
            let qty = 0;

            cart.items.forEach(function (item) {
                if (item.selling_plan_allocation) return;
                if (ids.indexOf(String(item.variant_id)) !== -1) {
                    qty += item.quantity;
                }
            });

            setRowQty(row, qty);
        });
    }

    function setRowQty(row, newQty) {
        if (newQty < 0) newQty = 0;

        const input = row.querySelector('.bb-qty-input');
        const addBtn = row.querySelector('[data-bb-add]');
        const qtyWrap = row.querySelector('.bb-qty');

        input.value = newQty;

        if (newQty > 0) {
            addBtn.classList.add('is-hidden');
            qtyWrap.classList.remove('is-hidden');
            row.classList.add('is-active');
        } else {
            addBtn.classList.remove('is-hidden');
            qtyWrap.classList.add('is-hidden');
            row.classList.remove('is-active');
        }

        refreshAtc();
    }

    rows.forEach(function (row) {
        const addBtn = row.querySelector('[data-bb-add]');
        const minusBtn = row.querySelector('[data-bb-minus]');
        const plusBtn = row.querySelector('[data-bb-plus]');
        const input = row.querySelector('.bb-qty-input');
        const available = row.dataset.variantAvailable === 'true';

        if (addBtn && available) {
            addBtn.addEventListener('click', function () {
                setRowQty(row, 1);
            });
        }

        if (plusBtn) {
            plusBtn.addEventListener('click', function () {
                const v = parseInt(input.value, 10) || 0;
                setRowQty(row, v + 1);
            });
        }

        if (minusBtn) {
            minusBtn.addEventListener('click', function () {
                const v = parseInt(input.value, 10) || 0;
                setRowQty(row, v - 1);
            });
        }

        if (input) {
            input.addEventListener('change', function () {
                const v = parseInt(input.value, 10) || 0;
                setRowQty(row, v);
            });
        }
    });

    function getSectionsToFetch() {
        const sectionsToBundle = [];

        document.documentElement.dispatchEvent(
            new CustomEvent('cart:prepare-bundled-sections', {
                bubbles: true,
                detail: { sections: sectionsToBundle }
            })
        );

        return sectionsToBundle;
    }

    if (atcBtn) {
        atcBtn.addEventListener('click', async function (e) {
            e.preventDefault();

            const items = [];

            rows.forEach(function (row) {
                const qty = parseInt(row.querySelector('.bb-qty-input').value, 10) || 0;
                if (qty > 0) {
                    items.push({ id: row.dataset.variantId, quantity: qty });
                }
            });

            if (items.length === 0) return;

            atcBtn.disabled = true;
            const prevText = atcText.textContent;
            atcText.textContent = 'Adding...';

            const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            const sectionsToBundle = getSectionsToFetch();

            document.documentElement.dispatchEvent(
                new CustomEvent('theme:loading:start', { bubbles: true })
            );

            try {
                const response = await fetch(root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                        items: items,
                        sections: sectionsToBundle.join(','),
                        sections_url: window.location.pathname
                    })
                });

                document.documentElement.dispatchEvent(
                    new CustomEvent('theme:loading:end', { bubbles: true })
                );

                const responseJson = await response.json();

                if (!response.ok || (responseJson && responseJson.status)) {
                    console.error('ATC error:', responseJson.description || responseJson.message);
                    atcText.textContent = prevText;
                    refreshAtc();
                    return;
                }

                if (
                    window.themeVariables &&
                    (window.themeVariables.settings.cartType === 'page' ||
                        window.themeVariables.settings.pageType === 'cart')
                ) {
                    window.location.href = root + 'cart';
                    return;
                }

                const cartContent = await (await fetch(root + 'cart.js')).json();
                cartContent.sections = responseJson.sections;

                document.documentElement.dispatchEvent(
                    new CustomEvent('cart:change', {
                        bubbles: true,
                        detail: {
                            baseEvent: 'variant:add',
                            cart: cartContent
                        }
                    })
                );

                refreshAtc();
            } catch (err) {
                document.documentElement.dispatchEvent(
                    new CustomEvent('theme:loading:end', { bubbles: true })
                );
                console.error('Bundle ATC error:', err);
                atcText.textContent = prevText;
                refreshAtc();
            }
        });
    }

    rows.forEach(function (row) {
        const qty = parseInt(row.querySelector('.bb-qty-input').value, 10) || 0;
        if (qty > 0) {
            setRowQty(row, qty);
        }
    });

    document.addEventListener('cart:change', function (evt) {
        if (evt && evt.detail && evt.detail.cart) {
            syncRowsFromCart(evt.detail.cart);
        }
    });

    initPopup(section, setRowQty, rows);

    refreshAtc();

    window.addEventListener('resize', updateTierTrack);
}

function initPopup(section, setRowQty, rows) {
    const popup = section.querySelector('[data-bb-popup]');
    const popupContent = section.querySelector('[data-bb-popup-content]');
    const closeBtn = section.querySelector('.bb-popup__close');

    if (!popup || !popupContent) return;

    function closePopup() {
        popup.hidden = true;
        popupContent.innerHTML = '';
        popup.removeAttribute('aria-labelledby');
        document.body.classList.remove('bb-popup-open');
    }

    function openPopup(variantId) {
        const template = section.querySelector('[data-bb-popup-template="' + variantId + '"]');
        if (!template) return;

        popupContent.innerHTML = '';
        popupContent.appendChild(template.content.cloneNode(true));

        const title = popupContent.querySelector('.bb-popup__title');
        if (title && title.id) {
            popup.setAttribute('aria-labelledby', title.id);
        }

        const addBtn = popupContent.querySelector('[data-bb-popup-add]');
        if (addBtn) {
            addBtn.addEventListener('click', function () {
                const row = rows.find(function (r) {
                    return r.dataset.variantId === String(variantId);
                });

                if (row) {
                    const input = row.querySelector('.bb-qty-input');
                    const currentQty = parseInt(input.value, 10) || 0;
                    setRowQty(row, currentQty > 0 ? currentQty + 1 : 1);
                }

                closePopup();
            });
        }

        popup.hidden = false;
        document.body.classList.add('bb-popup-open');

        if (closeBtn) {
            closeBtn.focus();
        }
    }

    section.querySelectorAll('[data-bb-popup-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            openPopup(btn.dataset.variantId);
        });
    });

    section.querySelectorAll('[data-bb-popup-close]').forEach(function (el) {
        el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape' && !popup.hidden) {
            closePopup();
        }
    });
}
